import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useSubmitPatientMatch({ onSuccess }: { onSuccess?: () => void } = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostMutation(),
    onSuccess: (_, variables) => {
      onSuccess?.()
      queryClient.removeQueries(
        apiClient.getDocumentPatientMatchesDocumentsKeyPatientMatchesGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
      queryClient.invalidateQueries(
        apiClient.getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
    },
  })
}
